<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api_crm.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Orders from '../components/Orders.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 

    import Pagination from '../components/Pagination.svelte'; 
    import { DatePicker } from "@svelte-plugins/datepicker";
    import { updateUrlParam } from '../base/url.js';
    import { format } from 'date-fns';

    let isLoading = false;



    export let params = {};

    let object_id = params.object_id;
    let searchTerm = '';
    let prevsearchTerm = '';
    let items = [];
    let filteredItems = [];
    let name = '';
    let count = 0;
    let loader = false;
    let pages = 1;
    let limit = 10;
    let currentPage = 1;
    let sort = '';
    let sortDirection = 1;
    let urlParams = {}

    
    onMount(fetchUIConfiguration);

    async function fetchUIConfiguration() {

        //console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }


        const url = new URL(window.location);
        const hashParams = new URLSearchParams(url.hash.split('?')[1]);
        const pageParam = hashParams.get('page');
        const searchParam = hashParams.get('search');
        const sortParam = hashParams.get('sort');
        const sortDirectionParam = hashParams.get('sort_direction');

        if (searchParam) {
            searchTerm = searchParam;
        }

        if (pageParam) {
            currentPage = pageParam;
        }

        sort = sortParam;
 
        if (sortDirectionParam) {
            sortDirection = sortDirectionParam;
            if (sortDirection=="true") {
                sortDirection = 1;
            } else {
                sortDirection = 0;
            }
        }
        

        isLoading = true;        

        if (prevsearchTerm!=searchTerm) {
            currentPage = 1;  
            urlParams.page = currentPage;     
            updateUrlParam(urlParams)              
        }

        let postData = {
            action : 'index',
            object : params.object_id,
            limit : limit,
            page : currentPage,
            sort : sort,
            sort_direction : sortDirection
        }

        if (searchTerm!='') {
            postData.search = searchTerm;
        }

        prevsearchTerm = searchTerm;

        let results = await fetchData(postData);

        items = results.data;
        filteredItems = items
        name = results.name;
        count = results.count;
        //console.log(filteredItems);

        pages = results.count / limit

        isLoading = false;


        
        
    }

    $: if (params.object_id !== object_id) {
        object_id = params.object_id;
        searchTerm = '';
        fetchUIConfiguration();

    }


    const handleSubmit =  async () => {
        alert(1)
    }


    function formatDate(dateString) {
        return dateString;
        const date = new Date(dateString);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return dateString;
        }

        // Format the date to a more readable format
        return date.toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }

    const searchInObject = async(object_id) => {
        urlParams.search = searchTerm
        updateUrlParam(urlParams);  
        fetchUIConfiguration();       

    }

    function handleEnterKey() {
        searchTerm = searchTerm.trim();
        urlParams.search = searchTerm
        updateUrlParam(urlParams);  
        fetchUIConfiguration();
 
    }

    // Function to detect the key press and execute the function on 'Enter'
    function handleKeydown(event) {
        if (event.key === 'Enter') {
            handleEnterKey();
        }
    }

    const previous = async(event) => {

        currentPage = event.detail.currentPage;
        urlParams.page = currentPage
        updateUrlParam(urlParams);
        fetchUIConfiguration();

    }

    const next = async(event) => {

        currentPage = event.detail.currentPage;        
        urlParams.page = currentPage
        updateUrlParam(urlParams);  
        fetchUIConfiguration();    
    }

    const sortResults = async(field_id,sort_direction) => {

        urlParams.sort = field_id
        urlParams.sort_direction = !sort_direction
        updateUrlParam(urlParams); 
        fetchUIConfiguration();   


    }

    

    

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list"> 
            <h1>{name} {#if name}<span class="h1-records">- {count} {$_('crm.objects.total_records')}</span>{/if}</h1>
            <div class="objects-actions">
                <div class="objects-actions-cell">
                    <div class="input_box">
                        <div class="input_con">
                            <input type="text" placeholder="חיפוש..." class="object-search" bind:value={searchTerm} on:keydown={handleKeydown}>
                        </div>
                    </div>
                    <div class="input_box">
                        <div class="input_con">
                            <span class="button color-white" on:click={()=>{ searchInObject(object_id) }}><i class="fa-solid fa-magnifying-glass"></i></span>
                        </div>
                    </div>
                </div>
                <div class="objects-actions-cell">
                    <div class="inner">
                        <div><i class="fa-solid fa-file-arrow-down"></i></div>
                        <div><i class="fa-solid fa-table-cells-large"></i></div>
                        <div><i class="fa-solid fa-print"></i></div>
                        <div on:click={()=>{ push('/objects/'+object_id+'/settings') }}><i class="fa-solid fa-gear"></i></div>
                    </div>
                </div>
            </div>
            {#if Object.entries(filteredItems).length}
                <div class="table">
                    <div class="head">
                        <div></div>
                        {#each Object.keys(filteredItems[0]) as key}
                            {#if key=='id'}
                            <div on:click={()=> { sortResults('',sortDirection) }}>
                                ID
                                {#if sort == ''}                                    
                                    {#if sortDirection==1}
                                        <i class="fa-solid fa-arrow-down-wide-short"></i>                                                                          
                                    {:else}
                                    <i class="fa-solid fa-arrow-up-short-wide"></i>
                                    {/if}
                                {/if}
                            </div>
                            {/if}
                            {#if !key.includes("__") && filteredItems[0][key].hidden==false}
                            <div on:click={()=> { sortResults(filteredItems[0][key].field_id,sortDirection) } }>
                                {filteredItems[0][key].name}
                                {#if sort == filteredItems[0][key].field_id}
                                    
                                    {#if sortDirection==1}
                                        <i class="fa-solid fa-arrow-down-wide-short"></i>                                                                          
                                    {:else}
                                    <i class="fa-solid fa-arrow-up-short-wide"></i>
                                    {/if}
                                {/if}
                            </div>
                            {/if}
                        {/each}    
                        <div></div>
                    </div>
                {#each Object.keys(filteredItems) as index,key}
                    <div>
                        <div class="input_con radio checkbox">            
                            <input id="enabled{index}" type="checkbox">       
                            <label for="enabled{index}"><span></span></label>     
                        </div>
                        {#each Object.keys(filteredItems[key]) as key2}
                            {#if key2=='id' || (!filteredItems[key][key2].code.includes("__") && filteredItems[key][key2].hidden==false) }
                                <div class="row_field"  on:click={()=>{filteredItems[key][key2].edit=1}}>
                                    {#if key2=='id'}
                                        <a href="/objects/{params.object_id}/{filteredItems[key][key2].value}" use:link>{filteredItems[key][key2].value}</a>
                                    {:else}
                                        {#if filteredItems[key][key2].edit==1} 
                                            {#if filteredItems[key][key2].options.length}
                                            <select class="field_options" bind:value={filteredItems[key][key2].value}>
                                                {#each filteredItems[key][key2].options as option}
                                                    <option value="{option.name}">{option.name}</option>
                                                {/each}
                                            </select>
                                            {:else}
                                            <input type="text" bind:value={filteredItems[key][key2].value}>
                                            {/if}
                                        {:else}
                                        {filteredItems[key][key2].prefix}{filteredItems[key][key2].value}{filteredItems[key][key2].postfix}
                                        {/if}
                                    {/if}
                                </div>
                            {/if}
                       {/each}
                       <div>
                            <span class="button">
                                <a href="/objects/{params.object_id}/{filteredItems[key]['id'].value}" use:link>
                                {$_('crm.objects.open')}
                                </a>
                            </span>
                       </div>
                    </div>
                {/each}
                </div>                
            {:else}
                <div>{$_('crm.objects.records_not_found')}</div>
            {/if}
            <Pagination {pages} on:previous={previous} on:next={next} {currentPage}></Pagination>
        </div>
    </div>
</div>